import PropTypes from 'prop-types';
import React from 'react';

const ModerationDirectLink = ({ url, closeModal }) => (
    <a
        href={url}
        rel="noreferrer"
        target="_blank"
        className="component-Community-ModerationMenu-ModerationDirectLink"
        onClick={closeModal}
    >
        <style jsx>
            {`
                .component-Community-ModerationMenu-ModerationDirectLink {
                    display: flex;
                    align-items: center;
                    width: 100%;
                    font-size: 14px;
                    line-height: 34px;
                    color: #353535;
                    padding-top: 2px;
                }
                .component-Community-ModerationMenu-ModerationDirectLinka,
                .component-Community-ModerationMenu-ModerationDirectLink:link,
                .component-Community-ModerationMenu-ModerationDirectLink:visited {
                    color: #353535;
                    text-decoration: none;
                }
                .component-Community-ModerationMenu-ModerationDirectLink
                    .component-Icons-DirectLinkIcon {
                    margin-right: 10px;
                }
            `}
        </style>
        Direct link
    </a>
);

ModerationDirectLink.propTypes = {
    url: PropTypes.string.isRequired,
    closeModal: PropTypes.func,
};

ModerationDirectLink.defaultProps = {
    closeModal: () => {},
};

ModerationDirectLink.displayName = 'ModerationDirectLink';

export default React.memo(ModerationDirectLink);
